import { Typography } from '@mui/material'
import { IconButton } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import GalleryItem from '../../components/gallery/gallery-item'
import styles from './styles.module.css'

export default ({galleryData}) => (
    <div className={styles.galleryContainer}>
        <div className={styles.galleryHeader}>
            <Typography variant="h6" className={styles.galleryTitle}>Gallery</Typography>
            <div className={styles.actionGroup} style={{
                position: 'absolute',
                top: 0,
                right: 40,
                zIndex: 1,
            }}>
                <div className={styles.innerButtonBar}>
                    <IconButton
                        style={{ color: 'var(--text-primary)' }}

                        onClick={() => galleryData.refresh()}
                    >
                        <RefreshIcon />

                    </IconButton>
                </div>
            </div>
        </div>
        <div className={styles.galleryScrollArea}>
            <div style={{ marginTop: 15, marginBottom: 45, display: 'flex', gap: 25, flexDirection: 'row', flexWrap: "wrap" }}>
                {
                    galleryData?.data?.length > 0 ? galleryData?.data?.map(x => (
                        <GalleryItem {...x} refreshGallery={galleryData.refresh} />
                    )) : <div>No data to display</div>
                }
            </div>
        </div>
    </div>
)